import queryString from "qs";
export function parseQueryParams(search: string) {
    return queryString.parse(search.replace(/^\?/, ""));
}
